<template>
  <div>
    <v-text-field
      v-model="form.name"
      name="name"
      :rules="rules.name"
      :label="`${$t('PROFILE.NAME')} *`"
      :readonly="readonly"
    ></v-text-field>

    <v-text-field
      v-model="form.rooms"
      name="rooms"
      :rules="rules.rooms"
      :label="$t('APARTMENTS.ROOMS')"
      :readonly="readonly"
    ></v-text-field>

    <v-text-field
      v-model="form.floor"
      name="floor"
      :rules="rules.floor"
      :label="$t('APARTMENTS.FLOOR')"
      :readonly="readonly"
    ></v-text-field>

    <v-text-field
      v-model="form.emergency_key"
      name="floor"
      :rules="rules.emergency_key"
      :label="$t('APARTMENTS.EMERGENCY_KEY')"
      :readonly="readonly"
      :counter="12"
      outlined
    ></v-text-field>

    <v-textarea
      v-model="form.access_description"
      name="access_description"
      outlined
      :rules="rules.access_description"
      :label="$t('APARTMENTS.ACCESS_DESCRIPTION')"
      :readonly="readonly"
    ></v-textarea>

    <v-checkbox
      v-model="form.presentation"
      name="presentation"
      class="mt-0"
      :label="$t('APARTMENTS.FOR_PRESENTATION')"
      :readonly="readonly"
    ></v-checkbox>

    <v-checkbox
      v-model="form.is_smarthome"
      name="is_smarthome"
      class="mt-0"
      :label="$t('APARTMENTS.SMARTHOME')"
      readonly
    ></v-checkbox>

    <v-container>
      <slot name="buttons" />
    </v-container>
  </div>
</template>

<script>
import apartmentRules from './mixins/apartmentRules';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'ApartmentForm',

  mixins: [formEditable, apartmentRules],

  data() {
    return {
      form: {
        emergency_key: '',
        is_smarthome: false
      }
    };
  }
};
</script>
